import { Box } from '@mui/material'
import React from 'react'

import {
  getLogo,
  getPresetKeyFromURL
} from 'components/scenarios/create/status-checks/third-party-presets'
import { ObservabilityToolCustomIcon } from 'components/status-checks/common/ObservabilityToolCustomIcon'
import { muiTheme } from 'mui-theme'

import type {
  StatusCheck,
  TeamExternalIntegration
} from 'types/api/status-checks/status-check'

type ObservabilityToolIconProps =
  | { integration: TeamExternalIntegration; statusCheck?: never }
  | {
      integration?: never
      statusCheck: Pick<
        StatusCheck,
        'endpointConfiguration' | 'thirdPartyPresets'
      >
    }

const sxProps = {
  width: muiTheme.spacing(4),
  height: muiTheme.spacing(4)
}

export const ObservabilityToolIcon: React.FC<ObservabilityToolIconProps> = ({
  integration,
  statusCheck
}) => {
  const statusCheckLogoName = statusCheck
    ? statusCheck.thirdPartyPresets ??
      getPresetKeyFromURL(statusCheck.endpointConfiguration?.url)
    : undefined

  const integrationLogoName = integration
    ? integration.type ??
      integration.observabilityToolType ??
      getPresetKeyFromURL(integration.url)
    : undefined

  const logoName = statusCheckLogoName ?? integrationLogoName
  const altText = `${logoName} Logo`
  const logoSrc = getLogo(logoName) ?? undefined

  return logoSrc ? (
    <Box alt={altText} component="img" src={logoSrc} sx={sxProps} />
  ) : (
    <ObservabilityToolCustomIcon />
  )
}
